// Captions of one gallery (or the title bars of one box row) get the height of the longest one (two-line captions
// next to one-line ones look restless). figure.caption-fit figcaption and .box-title-overlay take their min-height
// from --caption-min-height (see scss/layout/_main-images.scss and components/_cards.scss);
// the value is measured per gallery and re-measured when the width or the fonts change.
const GROUP = '.tile-items, .image-container, .swiper-wrapper, .boxes-row';
const CAPTION = 'figure.caption-fit figcaption, .box-title-overlay';
const VAR = '--caption-min-height';

function equalize() {
    document.querySelectorAll(GROUP).forEach((group) => {
        const captions = group.querySelectorAll(CAPTION);
        if (captions.length < 2) {
            return;
        }

        group.style.removeProperty(VAR);
        let tallest = 0;
        captions.forEach((caption) => {
            // offsetHeight, not getBoundingClientRect(): the latter includes transforms (reveal effects such as
            // roll or zoom running while the page loads), which inflated the measured height
            tallest = Math.max(tallest, caption.offsetHeight);
        });
        if (tallest > 0) {
            group.style.setProperty(VAR, `${Math.ceil(tallest)}px`);
        }
    });
}

export default function initCaptionHeights() {
    if (!document.querySelector(CAPTION)) {
        return;
    }

    let frame = null;
    const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(equalize);
    };

    schedule();
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(schedule);
    }
}
